import React, { ComponentType, FC, useEffect, useState } from "react";
import { ListItemIcon } from "@material-ui/core";
import ArrowUpIcon from "@material-ui/icons/ExpandLessRounded";
import ArrowDownIcon from "@material-ui/icons/ExpandMoreRounded";
import { Props as NavItemChildProps } from "Components/Navigation/SideNav/NavItem/NavItemChild/NavItemChild";
import NavItemChild from "Components/Navigation/SideNav/NavItem/NavItemChild/NavItemChild";
import { useLocation } from "Hooks/useRouter";
import { matchPath } from "react-router";
import { NavListItem } from "../NavListItem/NavListItem";
import { NavListItemText } from "../NavListItem/NavListItemText/NavListItemText";
import useStyles from "./styles";

export type Props = {
  kind: "parent";
  label: string;
  Icon: ComponentType;
  childProps: NavItemChildProps[];
};

const NavItemParent: FC<Props> = ({ label, Icon, childProps }) => {
  const { pathname } = useLocation();

  const hasMatchedChild = matchChild(pathname, childProps);

  const [selected, setSelected] = useState(hasMatchedChild);
  const classes = useStyles({ selected });
  useEffect(() => {
    if (!matchChild(pathname, childProps)) setSelected(false);
  }, [pathname, childProps]);

  if (!childProps || !childProps.length) {
    return null;
  }

  return (
    <>
      <NavListItem
        button
        onClick={() => {
          setSelected(!selected);
        }}
        className={classes.root}
      >
        <ListItemIcon className={classes.icon}>
          <Icon />
        </ListItemIcon>

        <NavListItemText
          classes={{ primary: selected ? classes.selectedText : classes.text }}
          primary={label}
        />
        {selected ? <ArrowUpIcon /> : <ArrowDownIcon />}
      </NavListItem>
      <div className='nav-child-root'>
        {selected
          ? childProps.map(props => (
            <NavItemChild key={props.label} {...props} />
          ))
          : null}
      </div>
    </>
  );
};

function matchChild(pathname: string, childProps: NavItemChildProps[]) {
  for (let i = 0; i < childProps.length; i++) {
    const path = childProps[i].to;
    const exact = childProps[i].exact;
    if (matchPath(pathname, { path, exact })) return true;
  }
  return false;
}

export default NavItemParent;
